import { Truck, RotateCcw, Shield, Award } from "lucide-react";

const BADGES = [
  {
    icon: Truck,
    title: "Free Shipping",
    desc: "On orders over CHF 75",
  },
  {
    icon: RotateCcw,
    title: "30-Day Returns",
    desc: "Hassle-free exchanges",
  },
  {
    icon: Shield,
    title: "Secure Checkout",
    desc: "SSL encrypted payments",
  },
  {
    icon: Award,
    title: "Designed in Switzerland",
    desc: "Born in Switzerland",
  },
];

export default function TrustBadges() {
  return (
    <section data-testid="trust-badges" className="py-12 sm:py-16 border-y border-[#E5E5E5] bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {BADGES.map((badge) => (
            <div key={badge.title} className="flex flex-col items-center text-center">
              <badge.icon className="w-6 h-6 mb-3 text-[#0A0A0A]" strokeWidth={1.3} />
              <p
                className="text-xs tracking-[0.15em] uppercase text-[#0A0A0A] mb-1"
                style={{ fontStyle: "normal" }}
              >
                {badge.title}
              </p>
              <p className="text-xs text-[#888]" style={{ fontStyle: "normal" }}>
                {badge.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
